//menu
const menuOverlay = document.querySelector(".js-menu-overlay"),
    menuButton = document.querySelector(".js-menu-button"),
    headerLogo = document.querySelector(".js-site-logo"),
    navListEl = document.querySelectorAll(".js-nav-list li");

let isActive = false;

if (typeof menuButton != "undefined" && menuButton != null) {
    menuButton.addEventListener("click", () => {
        isActive = !isActive;
        if (isActive) {
            openMenuAnimations();
        } else {
            closeMenuAnimations();
        }
    });
}

if (typeof headerLogo != "undefined" && headerLogo != null) {
    headerLogo.addEventListener("click", () => {
        isActive = !isActive;
        if (isActive) {
            openMenuAnimations();
        } else {
            closeMenuAnimations();
        }
    });
}

const openMenuAnimations = () => {
    body.classList.add("stop-scrolling");
    menuButton.classList.add("is-active");
    headerLogo.classList.add("logo__nav-logo--menu-open");
    gsap.to(menuOverlay, 0.3, { autoAlpha: 1 });
    gsap.fromTo(
        navListEl,
        {
            x: 20,
            autoAlpha: 0
        },
        {
            x: 0,
            autoAlpha: 1,
            stagger: 0.05,
            ease: Back.easeOut.config(1.4)
        }
    );
};

const closeMenuAnimations = () => {
    body.classList.remove("stop-scrolling");
    menuButton.classList.remove("is-active");
    headerLogo.classList.remove("logo__nav-logo--menu-open");
    gsap.to(menuOverlay, 0.3, { autoAlpha: 0 });
};

window.addEventListener("resize", function () {
    isActive = false;
    closeMenuAnimations();
});

const tickers = document.querySelectorAll(".js-ticker");

tickers.forEach((ticker) => {
    const tickerInner = ticker.querySelector(".js-ticker-inner");
    const tickerHeight = tickerInner.offsetHeight;
    const time = ticker.dataset.time;

    tickerInner.childNodes.forEach((x) => {
        tickerInner.appendChild(x.cloneNode(true));
    });

    rhTickerMove(tickerInner, tickerHeight, time);
});

function rhTickerMove($element, tickerHeight, time) {
    gsap.fromTo(
        $element,
        {
            y: 0
        },
        {
            duration: time,
            y: -tickerHeight,
            ease: Linear.easeNone,
            onComplete: rhTickerMove,
            onCompleteParams: [$element, tickerHeight, time]
        }
    );
}

projectHover();
function projectHover() {
    const projectItem = document.querySelectorAll('.ticker-item'),
        projectTitle = document.getElementById('projectName'),
        projectClient = document.getElementById('projectClient'),
        projectInfo = document.getElementById('projectInfo'),
        isActiveClass = 'is-active';

    projectItem.forEach((item) => {

        const title = item.dataset.title;
        const client = item.dataset.client

        item.addEventListener('mouseenter', () => {
            projectTitle.textContent = title;
            projectClient.textContent = client;
            projectInfo.classList.add(isActiveClass);
        });

        item.addEventListener('mouseleave', () => {
            projectInfo.classList.remove(isActiveClass);
        });

    });
}